export default "__VITE_ASSET__419fc7f0__"